export default {
  LOADING: 'ACCOUNTS_VIEW_LOADING',
  LOADED: 'ACCOUNTS_VIEW_LOADED',
};
